// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3MMJU","topBottomGutter":"Layout_topBottomGutter__11P-t"};